/* eslint semi:0 */
import { urlWithQs, m } from '../../utils/mithril'
import {
  get as getFromPdo,
  getSiteDomainWithTld,
  getPostUrl,
} from '../../application/pageDataObject'
import { openEmbed } from '../actions/socialButtonsActions'
import { t, locale } from '../../providers/i18nProvider/i18nProvider'
require('scroll-to-element')

export const FACEBOOK = 'facebook'
export const TWITTER = 'twitter'
export const MESSAGE = 'message'
export const WHATSAPP = 'whatsapp'
export const EMBED = 'embed'
export const COMMENTS = 'comments'

const EMBED_CODE_FEATURE_ID = 'EmbedCode'

const TWITTER_VIA = {
  '90min.com': {
    default: '90min_Football',
  },
  'ftb90.com': {
    default: 'ftb_90',
  },
  '12up.com': {
    default: '12upSport',
    es: '12up_ES',
  },
  'minutemediaalpha.com': {
    default: 'Esp_Interativo',
  },
  'floor8.com': {
    default: 'Floor8Official',
    es: 'Floor8_ES',
  },
}

function twitterVia() {
  const forDomain = TWITTER_VIA[getSiteDomainWithTld()]
  return forDomain && (forDomain[locale] || forDomain.default)
}

export const SOCIAL_BUTTONS_CONF = {
  [FACEBOOK]: {
    title: 'Facebook',
    name: FACEBOOK,
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        u: urlWithQs(getPostUrl(), sharedUrlParams),
      }
      return urlWithQs('http://www.facebook.com/sharer.php', urlParams)
    },
    sourceName: 'facebook.com',
  },
  [TWITTER]: {
    title: t('common.tweet'),
    name: TWITTER,
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        text: getFromPdo('post.title', '').replace('|', '-'),
        via: twitterVia(),
        url: urlWithQs(getPostUrl(), sharedUrlParams),
      }
      return urlWithQs('http://twitter.com/share', urlParams)
    },
    sourceName: 'twitter.com',
  },
  [WHATSAPP]: {
    title: t('common.share'),
    name: WHATSAPP,
    sourceName: 'whatsapp',
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const postUrl = urlWithQs(getPostUrl(), sharedUrlParams)
      return [
        'whatsapp://send?text=',
        getFromPdo('post.title'),
        encodeURIComponent(`: ${postUrl}`),
      ].join('')
    },
  },
  [EMBED]: {
    featureId: EMBED_CODE_FEATURE_ID,
    title: t('embed.button'),
    name: EMBED,
    onClick: openEmbed,
  },
}

export default SOCIAL_BUTTONS_CONF



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/socialButtonsConfig.js